module.exports = __webpack_public_path__ + "img/2.e7b1f232.jpg";